module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_part1"
    }
  }, [_vm._v("PART ONE: A Whole New World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap1"
    }
  }, [_vm._v("Snapshots of Beranabus I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap2"
    }
  }, [_vm._v("Dead Girls Tell Tales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap3"
    }
  }, [_vm._v("Lonely New World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap4"
    }
  }, [_vm._v("First Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap5"
    }
  }, [_vm._v("Sponge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap6"
    }
  }, [_vm._v("Friend Indeed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap7"
    }
  }, [_vm._v("Waking the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap8"
    }
  }, [_vm._v("Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap9"
    }
  }, [_vm._v("Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap10"
    }
  }, [_vm._v("Waiting for the Cavalry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_part2"
    }
  }, [_vm._v("PART TWO: Ward Duty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap11"
    }
  }, [_vm._v("Snapshots of Beranabus II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap12"
    }
  }, [_vm._v("A Man’s Gotta Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap13"
    }
  }, [_vm._v("Up On the Roof")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap14"
    }
  }, [_vm._v("Kids’ Stuff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap15"
    }
  }, [_vm._v("The Split")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap16"
    }
  }, [_vm._v("Chasing Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_part3"
    }
  }, [_vm._v("PART THREE: All Aboard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap17"
    }
  }, [_vm._v("Snapshots of Beranabus III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap18"
    }
  }, [_vm._v("Kirilli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap19"
    }
  }, [_vm._v("Her Master’s Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap20"
    }
  }, [_vm._v("Ship of the Living Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap21"
    }
  }, [_vm._v("Going Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap22"
    }
  }, [_vm._v("The Only Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_chap23"
    }
  }, [_vm._v("All At Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/DeathsShadow_teas1"
    }
  }, [_vm._v("A Preview of “Wolf Island”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1c16104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeathsShadow_toc.vue
// module id = 60
// module chunks = 0